// extracted by mini-css-extract-plugin
export default {"option":"booking-target-radio__option___AGGMI"};